import React from "react";
import { HeroUIProvider } from "@heroui/system";
import { useNavigate } from "react-router-dom";

export function Provider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  return (
    <HeroUIProvider locale="en-US" navigate={navigate}>
      {children}
    </HeroUIProvider>
  );
}
